/* eslint-disable i18next/no-literal-string */
import { getSessionIdFromHtmlHiddenField } from '@src/components/user-details/user-details'
import { ANALYTIC_COOKIES } from '@src/quince-site-common/src/utils/constants'
import getCookie from '@src/quince-site-common/src/utils/getCookie'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'
import setCookie from '@src/quince-site-common/src/utils/setCookie'

import uniqueIdGenerator from '../uniqueIdGenerator'

export function getSessionId() {
  return getSessionIdFromHtmlHiddenField() ?? getCookie(ANALYTIC_COOKIES.SESSION_ID) ?? ''
}

export function createNewSession() {
  const isSecure = isBrowser() ? window.location.protocol === 'https:' : true
  const sessionId = uniqueIdGenerator('c-')
  setCookie(ANALYTIC_COOKIES.SESSION_ID, sessionId, 120, isSecure, false)

  // if (!getCookie(ANALYTIC_COOKIES.SESSION_ID)) {
  //   console.info('Quince cookies : session id is not present')
  //   const sessionId = uniqueIdGenerator('c-')
  //   console.info('Quince cookies : setting session id - ', sessionId)
  //   setCookie(ANALYTIC_COOKIES.SESSION_ID, sessionId, 120, isSecure, false)
  //   // setInLocalStorageWithExpiry(ANALYTIC_COOKIES.SESSION_ID, sessionId, 120)
  // } else {
  //   // If session is already present then extending session further by approx 2 hour
  //   console.info('Quince cookies : session id already present, extending by 2 hours')
  //   setCookie(ANALYTIC_COOKIES.SESSION_ID, getCookie(ANALYTIC_COOKIES.SESSION_ID), 120, isSecure, false)
  //   // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  //   // setInLocalStorageWithExpiry(ANALYTIC_COOKIES.SESSION_ID, getCookie(ANALYTIC_COOKIES.SESSION_ID)!, 120)
  // }
}
/* eslint-enable i18next/no-literal-string */
